var noop = function noop() {};

export { noop as n };